import React from "react";

const BearSadIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M21.0863 15.2075C22.0337 18.8017 18.4164 22.0406 15.115 22.0406C11.8136 22.0406 7.6509 18.6787 9.17243 15.2075C10.9236 11.2853 11.8423 8.37441 15.115 8.37441C18.3877 8.37441 20.0241 11.34 21.0863 15.2075Z"
      stroke="currentColor"
      strokeWidth="1.3"
      strokeMiterlimit="10"
    />
    <path
      d="M20.0243 15.2075C20.2075 15.9911 20.2126 16.8028 20.0392 17.5884C19.8658 18.374 19.5181 19.1152 19.0192 19.7623C18.5203 20.4094 17.8818 20.9475 17.1466 21.3404C16.4114 21.7334 15.5965 21.9721 14.7564 22.0406C11.8856 22.0406 8.15353 18.6787 9.50281 15.2075C11.0387 11.2853 11.8569 8.37441 14.7564 8.37441C17.6559 8.37441 19.0483 11.34 20.0243 15.2075Z"
      stroke="currentColor"
      strokeWidth="1.3"
      strokeMiterlimit="10"
    />
    <path
      d="M17.2966 14.3329C17.1094 14.7863 16.8029 15.1863 16.4066 15.4945C15.9925 15.81 15.4966 16.013 14.9712 16.0821C14.4766 15.982 14.0141 15.7712 13.6219 15.4672C13.227 15.1658 12.9163 14.7761 12.7176 14.3329C12.2583 13.4309 12.2153 12.5836 14.9712 12.5836C17.9999 12.5836 17.7272 13.4172 17.2966 14.3329Z"
      fill="currentColor"
    />
    <path
      d="M14.9434 27.9991C14.9434 27.9991 22.1205 26.5504 25.0917 22.7239C26.2136 21.4572 26.9776 19.9391 27.3117 18.313C27.6457 16.687 27.5387 15.0066 27.0008 13.4309C26.2401 11.217 25.1635 8.93471 25.1635 8.93471C29.197 6.40646 27.9482 4.27453 26.9578 3.05824C26.4697 2.45692 24.2161 0.324995 21.2161 4.72551H8.82858C5.81423 0.37966 3.56064 2.45692 3.08695 3.05824C2.12523 4.27453 0.862073 6.40646 4.88121 8.93471C4.88121 8.93471 3.80466 11.3263 3.04389 13.4309C2.53957 15.0113 2.45123 16.6855 2.78665 18.3061C3.12207 19.9267 3.87096 21.4438 4.96734 22.7239C7.55107 26.1678 14.9434 27.9991 14.9434 27.9991Z"
      stroke="currentColor"
      strokeWidth="1.3"
      strokeMiterlimit="10"
    />
    <path
      d="M14.2833 27.9991C14.2833 27.9991 21.1015 26.5505 23.9292 22.7239C25.0121 21.437 25.746 19.9163 26.0664 18.2958C26.3868 16.6753 26.2838 15.0046 25.7665 13.4309C25.0058 11.217 24.0153 8.93472 24.0153 8.93472C27.8335 6.40647 26.8861 4.01488 25.7235 3.05825C25.1206 2.56626 23.4125 2.03328 21.1876 4.72553H8.54165C5.67084 0.379671 3.48902 2.45694 3.01534 3.05825C2.06797 4.27454 0.890934 6.40647 4.72347 8.93472C4.72347 8.93472 3.70433 11.3263 2.98663 13.4309C2.49061 15.0036 2.39331 16.6658 2.70272 18.2812C3.01212 19.8966 3.7194 21.4192 4.76653 22.7239C7.27849 26.1678 14.2833 27.9991 14.2833 27.9991Z"
      stroke="currentColor"
      strokeWidth="1.3"
      strokeMiterlimit="10"
    />
    <path
      d="M10.6221 20.018C10.6221 20.018 14.0096 15.1392 19.0192 19.608"
      stroke="currentColor"
      strokeWidth="1.3"
      strokeMiterlimit="10"
    />
    <path
      d="M10.6221 20.018C10.6221 20.018 13.9666 15.1802 18.4737 20.1"
      stroke="currentColor"
      strokeWidth="1.3"
      strokeMiterlimit="10"
    />
  </svg>
);

export default BearSadIcon;
